import { render } from "./RevisionLocation.vue?vue&type=template&id=2adbcdf2&scoped=true"
import script from "./RevisionLocation.vue?vue&type=script&lang=js"
export * from "./RevisionLocation.vue?vue&type=script&lang=js"

import "./RevisionLocation.vue?vue&type=style&index=0&id=2adbcdf2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2adbcdf2"]])

export default __exports__